import React from "react";
import { useTranslation } from "react-i18next";
import { StepComponentProps } from "./types";

export const ReviewStep: React.FC<StepComponentProps> = ({ formData }) => {
  const { t } = useTranslation();

  return (
    <div className="bg-pink-50 dark:bg-pink-900/20 rounded-lg p-4 border border-primary/10 dark:border-primary/30">
      <h3 className="text-sm font-bold text-primary dark:text-primary mb-3">
        {t("auth.registration.reviewDetails")}
      </h3>
      <ul className="text-gray-700 dark:text-gray-300 space-y-1 text-sm">
        <li>
          <span className="font-semibold">{t("auth.registration.name")}:</span>{" "}
          {formData.name}
        </li>
        <li>
          <span className="font-semibold">
            {t("auth.registration.loginMethod")}:
          </span>{" "}
          {t(`auth.registration.${formData.loginMethod}`)}
        </li>
        {formData.loginMethod === "email" && (
          <li>
            <span className="font-semibold">
              {t("auth.registration.email")}:
            </span>{" "}
            {formData.email}
          </li>
        )}
        {formData.loginMethod === "phone" && (
          <li>
            <span className="font-semibold">
              {t("auth.registration.phone")}:
            </span>{" "}
            {formData.phone}
          </li>
        )}
        {formData.loginMethod === "aadhar" && (
          <li>
            <span className="font-semibold">
              {t("auth.registration.aadhar")}:
            </span>{" "}
            {formData.aadhar}
          </li>
        )}
        {formData.referralCode && (
          <li>
            <span className="font-semibold">
              {t("auth.registration.referralCode")}:
            </span>{" "}
            {formData.referralCode}
          </li>
        )}
      </ul>
    </div>
  );
};
